import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || '';

// 图库：看过一次，就不会忘
function Gallery() {
  var navigate = useNavigate();
  var [items, setItems] = useState([]);
  var [loading, setLoading] = useState(true);
  var [err, setErr] = useState('');
  var [cur, setCur] = useState(null);        // 打开的那张
  var [editing, setEditing] = useState(false);
  var [titleDraft, setTitleDraft] = useState('');
  var [toast, setToast] = useState('');

  var flash = function(t) { setToast(t); setTimeout(function() { setToast(''); }, 1800); };

  var load = function() {
    setLoading(true); setErr('');
    fetch(API + '/api/gallery').then(function(r) { return r.json(); }).then(function(d) {
      if (!Array.isArray(d)) throw new Error(d && d.error ? d.error : 'bad data');
      setItems(d); setLoading(false);
    }).catch(function(e) { setErr(e.message); setLoading(false); });
  };
  useEffect(function() { load(); }, []);

  var fmtDate = function(s) {
    if (!s) return '';
    try { return new Date(s).toLocaleDateString('zh-CN', { timeZone: 'Asia/Hong_Kong', month: 'numeric', day: 'numeric', year: 'numeric' }); } catch (e) { return ''; }
  };

  var saveTitle = async function() {
    if (!cur) return;
    var t = titleDraft.trim();
    try {
      var r = await fetch(API + '/api/gallery/' + cur.id, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ title: t }) });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      setItems(function(prev) { return prev.map(function(x) { return x.id === cur.id ? Object.assign({}, x, { title: t }) : x; }); });
      setCur(Object.assign({}, cur, { title: t }));
      setEditing(false); flash('改好了');
    } catch (e) { flash('没存上：' + e.message); }
  };

  var hideOne = async function() {
    if (!cur) return;
    if (!window.confirm('从图库里收起这张？（原图还在，哥哥的记忆也还在，只是不在这里显示）')) return;
    try {
      var r = await fetch(API + '/api/gallery/' + cur.id, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ hidden: true }) });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      setItems(function(prev) { return prev.filter(function(x) { return x.id !== cur.id; }); });
      setCur(null); flash('收起来了');
    } catch (e) { flash('没成：' + e.message); }
  };

  var bringToChat = function() {
    if (!cur) return;
    try { sessionStorage.setItem('gallery_bring', JSON.stringify({ url: cur.url, title: cur.title || '' })); } catch (e) {}
    navigate('/chat');
  };

  var S = {
    page: { minHeight: '100vh', background: 'var(--bg, #F8F8F6)', color: 'var(--text, #3d3529)', paddingBottom: 90, fontFamily: "'Noto Serif SC', Georgia, serif" },
    header: { padding: '18px 20px 10px', display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' },
    h1: { fontSize: 26, fontWeight: 500, margin: 0 },
    sub: { fontSize: 12, color: 'var(--text3, #9a8b78)' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6, padding: '0 12px' },
    cell: { position: 'relative', aspectRatio: '1 / 1', borderRadius: 10, overflow: 'hidden', background: 'var(--accent3, rgba(176,137,104,0.08))', cursor: 'pointer' },
    img: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
    cap: { position: 'absolute', left: 0, right: 0, bottom: 0, padding: '14px 8px 6px', fontSize: 11, color: '#fff', background: 'linear-gradient(transparent, rgba(0,0,0,0.55))', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
    badge: { position: 'absolute', top: 6, right: 6, fontSize: 10, padding: '2px 6px', borderRadius: 8, background: 'rgba(0,0,0,0.45)', color: '#fff' },
    empty: { textAlign: 'center', padding: '80px 30px', color: 'var(--text3, #9a8b78)', fontSize: 14, lineHeight: 1.8 },
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 50, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
    sheet: { width: '100%', maxWidth: 560, maxHeight: '92vh', overflowY: 'auto', background: 'var(--card, #fff)', borderRadius: '18px 18px 0 0', padding: '14px 18px 28px' },
    big: { width: '100%', maxHeight: '48vh', objectFit: 'contain', borderRadius: 12, background: 'var(--accent3, rgba(176,137,104,0.08))' },
    label: { fontSize: 11, color: 'var(--text3, #9a8b78)', marginTop: 14, marginBottom: 4, letterSpacing: 1 },
    para: { fontSize: 13.5, lineHeight: 1.8, color: 'var(--text2, #6b5e4f)', whiteSpace: 'pre-wrap' },
    row: { display: 'flex', gap: 8, marginTop: 18 },
    btn: { flex: 1, padding: '11px 0', borderRadius: 10, border: '1px solid var(--border, rgba(176,137,104,0.2))', background: 'transparent', color: 'var(--text2, #6b5e4f)', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit' },
    btnMain: { flex: 1.4, padding: '11px 0', borderRadius: 10, border: 'none', background: 'var(--accent, #B96747)', color: '#fff', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit' },
    titleRow: { display: 'flex', alignItems: 'center', gap: 8, marginTop: 12 },
    title: { fontSize: 18, fontWeight: 500, flex: 1 },
    input: { flex: 1, fontSize: 16, padding: '8px 10px', borderRadius: 8, border: '1px solid var(--border, rgba(176,137,104,0.2))', background: 'var(--bg, #F8F8F6)', color: 'inherit', fontFamily: 'inherit' },
    small: { fontSize: 12, color: 'var(--text3, #9a8b78)', background: 'none', border: 'none', cursor: 'pointer', padding: '4px 6px', fontFamily: 'inherit' },
    toast: { position: 'fixed', top: 14, left: '50%', transform: 'translateX(-50%)', background: 'var(--accent, #B96747)', color: '#fff', padding: '8px 16px', borderRadius: 20, fontSize: 13, zIndex: 60 },
  };

  return (
    <div style={S.page}>
      {toast && <div style={S.toast}>{toast}</div>}
      <div style={S.header}>
        <h1 style={S.h1}>图库</h1>
        <div style={S.sub}>{items.length ? items.length + ' 张 · 看过一次就不会忘' : ''}</div>
      </div>

      {err && <div style={{ margin: '0 16px 12px', padding: 10, borderRadius: 8, border: '1px dashed var(--accent, #B96747)', color: 'var(--accent, #B96747)', fontSize: 12, cursor: 'pointer' }} onClick={load}>加载失败：{err}，点这里重试</div>}
      {loading && !items.length && <div style={S.empty}>加载中…</div>}
      {!loading && !items.length && !err && (
        <div style={S.empty}>还是空的。<br />在聊天里给哥哥发的图会自己出现在这里，<br />带着他第一眼的印象。</div>
      )}

      <div style={S.grid}>
        {items.map(function(it) {
          return (
            <div key={it.id} style={S.cell} onClick={function() { setCur(it); setEditing(false); setTitleDraft(it.title || ''); }}>
              <img src={it.url} alt={it.title || ''} style={S.img} loading="lazy" />
              {it.seen_count > 1 && <div style={S.badge}>×{it.seen_count}</div>}
              {it.title && <div style={S.cap}>{it.title}</div>}
            </div>
          );
        })}
      </div>

      {cur && (
        <div style={S.overlay} onClick={function() { setCur(null); }}>
          <div style={S.sheet} onClick={function(e) { e.stopPropagation(); }}>
            <img src={cur.url} alt="" style={S.big} />
            <div style={S.titleRow}>
              {editing ? (
                <>
                  <input style={S.input} value={titleDraft} maxLength={40} autoFocus onChange={function(e) { setTitleDraft(e.target.value); }}
                    onKeyDown={function(e) { if (e.key === 'Enter') saveTitle(); if (e.key === 'Escape') setEditing(false); }} />
                  <button style={S.small} onClick={saveTitle}>保存</button>
                  <button style={S.small} onClick={function() { setEditing(false); }}>取消</button>
                </>
              ) : (
                <>
                  <div style={S.title}>{cur.title || '（还没起名）'}</div>
                  <button style={S.small} onClick={function() { setEditing(true); }}>改名</button>
                </>
              )}
            </div>
            <div style={S.sub}>
              第一次见 {fmtDate(cur.first_seen_at)}{cur.seen_count > 1 ? ' · 一共见过 ' + cur.seen_count + ' 次，最近 ' + fmtDate(cur.last_seen_at) : ''}
            </div>

            <div style={S.label}>画面</div>
            <div style={S.para}>{cur.visual_description || '哥哥还没来得及整理这张（发过去几秒后会补上）。'}</div>

            <div style={S.label}>哥哥第一眼</div>
            <div style={S.para}>{cur.first_impression || '（没记下）'}</div>

            <div style={S.row}>
              <button style={S.btn} onClick={hideOne}>收起</button>
              <button style={S.btnMain} onClick={bringToChat}>带去聊天</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
